export default __webpack_public_path__ + "static/media/avatar_tommy_pyper4.dc6e853c.mp3";